import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { RootState } from "@/store/store";
import { ROUTE_PATH } from "@/constants/routeConstants";

const Index = () => {
  const { isAuthenticated, rehydrated } = useSelector(
    (state: RootState) => state.auth
  );
  const navigate = useNavigate();
  const location = useLocation();
  const hasNavigated = useRef(false);
  const navigationTimer = useRef<number | undefined>(undefined);

  useEffect(() => {
    // Don't navigate if we already did
    if (hasNavigated.current) return;
    
    if (!rehydrated) return;
    
    // Don't redirect if we have OAuth params (let AuthRedirectHandler handle it)
    const urlParams = new URLSearchParams(location.search);
    const hasAuthParams = urlParams.has('code') || urlParams.has('state') || urlParams.has('error');
    if (hasAuthParams) return;
    
    // Debounce navigation to prevent rapid loops
    if (navigationTimer.current) {
      clearTimeout(navigationTimer.current);
    }
    
    navigationTimer.current = window.setTimeout(() => {
      hasNavigated.current = true;
      
      if (isAuthenticated) {
        navigate(ROUTE_PATH.ROUTE_DASHBOARD, { replace: true });
      } else {
        navigate(ROUTE_PATH.ROUTE_LOGIN, { replace: true });
      }
    }, 100);
    
    return () => {
      if (navigationTimer.current) {
        clearTimeout(navigationTimer.current);
      }
    };
  }, [isAuthenticated, navigate, rehydrated, location.search]);

  if (!rehydrated) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-background'>
        <div className='animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600'></div>
      </div>
    );
  }

  return null;
};

export default Index;
